import { AssignmentInd } from '@mui/icons-material';
import { Typography } from '@mui/material';

type MemberDetailBirthDateProps = {
  birthDate: string | undefined;
  small?: boolean;
};

export const MemberDetailBirthDate = (props: MemberDetailBirthDateProps) => {
  const { birthDate, small = false } = props;
  if (!birthDate) return null;
  return (
    <Typography variant={small ? 'body2' : 'body1'} sx={{ display: 'flex', alignItems: 'center' }}>
      <AssignmentInd sx={{ mr: 1, fontSize: small ? '0.9rem' : 'inherit' }} />
      <span>{birthDate}</span>
    </Typography>
  );
};
